// extracted by mini-css-extract-plugin
module.exports = {"b2b__partnerLogo":"_38UITN7ya9a85LQ_mCzdlZ"};